import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";

export const statusLabel: Record<ShiftProductionFormListItem["status"], string> = {
  DRAFT: "Taslak",
  RETURNED: "Düzeltmede",
  PENDING_SHIFT_SUPERVISOR: "Vardiya amiri onayı",
  PENDING_PRODUCTION_ENGINEER: "Üretim şefi onayı",
  PENDING_PRODUCTION_MANAGER: "Üretim müdürü onayı",
  COMPLETED: "Tamamlandı",
};

export function statusClass(status: ShiftProductionFormListItem["status"]) {
  if (status === "COMPLETED") return "completed";
  if (status === "RETURNED") return "returned";
  return "pending";
}
